<template>
    <div
        class="flex items-center h-[40px] w-full relative bg-white"
        :class="[
            divideGroups ? 'justify-center' : 'justify-start',
            border && 'border-b border-[#E9EEF2]'
        ]"
    >
        <div
            class="hidden md:flex items-center"
            :class="divide ? 'space-x-2 divide-x divide-[#DBDBDC] md:absolute left-0' : ''"
        >
            <pdf-undo-redo class="pl-4" />
            <pdf-perspective class="pl-2" v-if="compact === false"/>
            <pdf-pagination
                class="pl-2"
                :key="numberOfPages"
                @move-up="() => scrollToPage(currentPage-1)"
                @move-down="() => scrollToPage(currentPage+1)"
                :currentPage="currentPage"
                :nrOfPages="numberOfPages"
                v-if="compact === false"
            />
        </div>

        <div
            id="onboarding-builder-style-builder"
            data-step="5"
            class="flex items-center"
            :class="divide ? 'space-x-2 divide-x divide-[#DBDBDC]' : ''"
        >
            <PdfFontType class="pl-2" v-if="compact === false"/>
            <div class="flex items-center justify-center relative">
                <pdf-formatting class="pl-2" />
            </div>
            <pdf-change-color class="pl-2"/>
            <pdf-text-size class="pl-2"/>
            <pdf-line-height class="pl-2" v-if="compact === false"/>
            <div class="pl-2">
                <EditMargins/>
            </div>
            <Indentation class="pl-2"/>
            <pdf-hyperlink class="pl-2"/>
            <pdf-reset-margins class="pl-2" v-if="compact === false"/>
            <pdf-reset-cover-letter
                v-if="isOnCoverLetterEditor"
                @click="regenerateCoverLetterPrompt"
                class="pl-2"
            />
            <pdf-change-template
                v-if="!isOnCoverLetterEditor && templates.length"
                class="pl-2"
                @click="changePDFTemplate"
            />
        </div>
        
        <pdf-regenerate-section
            v-if="isOnCoverLetterEditor"
            @regenerate="regenerateCoverLetter"
        />
    </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from "vue-router";
import PdfFontType from "./pdf-fonttype.vue";
import PdfHyperlink from "./pdf-hyperlink.vue";
import PdfPerspective from "./pdf-perspective.vue";
import PdfPagination from "./pdf-pagination.vue";
import PdfLineHeight from "./pdf-line-height.vue";
import Indentation from "./indent.vue";
import PdfFormatting from "./pdf-formatting.vue";
import PdfUndoRedo from "./pdf-undo-redo.vue";
import PdfRegenerateSection from "./pdf-regenerate-section.vue";
import PdfTextSize from "./pdf-text-size.vue";
import PdfChangeTemplate from "./pdf-change-template.vue";
import PdfChangeColor from "./pdf-change-color.vue";
import PdfResetMargins from "./pdf-reset-margins.vue";
import PdfResetCoverLetter from "./pdf-reset-cover-letter.vue";
import EditMargins from "../../components/pdf-builder/components/editor-top-bar/margins.vue"

const emit = defineEmits(["regenerate", "change-page", "regenerate-cover-letter-prompt", "change-template"]);
const props = defineProps({
    isOnCoverLetterEditor: {
        type: Boolean,
        default: false
    },
    numberOfPages: {
        type: Number,
        default: 0
    },
    currentPage: {
        type: Number,
        default: 0
    },
    templates: {
        type: Array,
        default: []
    },
    divide: {
        type: Boolean,
        default: true
    },
    divideGroups: {
        type: Boolean,
        default: true
    },
    compact: {
        type: Boolean,
        default: false
    },
    border: {
        type: Boolean,
        default: true
    }
})

const route = useRoute()

const isOnCoverLetterEditor = computed(() => {
    return route.meta?.coverLetter || false
})

const changePDFTemplate = () => {
    emit("change-template");
}

const regenerateCoverLetterPrompt = () => {
    emit("regenerate-cover-letter-prompt");
}

const regenerateCoverLetter = (allText) => {
    emit("regenerate", allText);
}

const scrollToPage = (page) => {
    emit('change-page', page);
}
</script>
